export default "__VITE_ASSET__CtY$niGz__"